/**
 * @returns The initials of the person's first and last name.
 */
export function getNameInitials(name?: string): string {
  if (!name) {
    return ''
  }

  const [firstName, lastName] = name.split(' ')
  return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`
}
